import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 20.8.",
  "description": "",
  "published": "2011-08-20T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-20-8/swizec/2268"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/photo2-300x224.jpg",
        "alt": null,
        "title": "Vegan food"
      }}></img></p>
    <p>{`Today I learned that despite being the biggest carnivore you are likely to meet I can actually enjoy a vegan lunch when it's done right. Was on a shopping spree in San Francisco today because I need some clothes and they're somewhat cheap this side of the pond. Part of the trip involved lunch and we went to an interesting place on Valencia called `}<a parentName="p" {...{
        "href": "http://www.herbivorerestaurant.com/"
      }}>{`Herbivore`}</a>{`.`}</p>
    <p>{`It's a fully vegan restaurant that actually serves good food. The fake chicken I ate was so awesome I would never have guessed it wasn't real chicken if I didn't know in advance.`}</p>
    <p>{`Another thing I learned is that in the US it is in fact possible to get pulled over by a cop while riding a bicycle. Got confused at a very big crossroads and somehow ended up running a red light in a very very confused manner. Wanted to go left, but I couldn't, then the lights started changing and everything went south quick.`}</p>
    <p>{`Whoo-whoop from a police bike and I was explaining myself to a cop. Got out scot free simply because I'm foreign and weird, but was told in a very sarcastic manner that here in the US you are supposed to stop when the light is red :D`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      